var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isInit
    ? _c(
        "div",
        { staticClass: "wangeditor-richtext" },
        [
          _c("h3", { staticClass: "edit-field-title" }, [
            _vm.field.name
              ? _c(
                  "div",
                  { staticClass: "label-item" },
                  [
                    _c("p", { staticClass: "label-text" }, [
                      _vm._v(_vm._s(_vm.field.desc))
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: { effect: "light", placement: "bottom-start" }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _vm._v("\n                    - name: "),
                            _c("strong", [_vm._v(_vm._s(_vm.field.name))]),
                            _c("br")
                          ]
                        ),
                        _vm._v(" "),
                        _c("i", { staticClass: "label-icon el-icon-info" })
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("wangEditor", {
            ref: "editorEle",
            attrs: { name: _vm.field.name || _vm.randomNum },
            on: {
              "init-complete": _vm.editorInitHandler,
              "editor-change": _vm.valChangeHandler
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62a93b2b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62a93b2b","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compEditForm/wangeditorRichtext.vue
// module id = 1224
// module chunks = 7